export const educationList = [
  {
    year: "Sep, 2023 - Present",
    description: "Working as a software engineer at PensionBox, backed by Zerodha",
  },
  {
    year: "Jun, 2022 - Aug, 2023",
    description: "Working as a frontend engineer at Binks",
  },
  {
    year: "Sep, 2022",
    description: "Part of Roc822' cohort where i grabbed few useful skills",
  },
  {
    year: "Aug, 2022",
    description:
      "Completed Bachelor's in Computer Applications from Anand Engineering College, Agra",
  },
  {
    year: "Jun, 2022",
    description:
      "Part of NeoG22' web dev bootcamp where i got a chance to have hands-on experience by creating macro projects",
  },
  {
    year: "2019",
    description:
      "Completed HSC with PCM+Computer from Christ The King Inter College, Tundla",
  },
  {
    year: "2017",
    description: "Completed SSC from Christ The King Inter College, Tundla",
  },
];
